const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const getLocalizationLoadPath = (version?: string, baseUrl = import.meta.env.BASE_URL) => {
  const normalizedBaseUrl = trimTrailingSlash(baseUrl || '/');
  const versionQuery = version ? `?v=${version}` : '';

  return `${normalizedBaseUrl}/locales/{{lng}}/{{ns}}.json${versionQuery}`;
};
